// extracted by mini-css-extract-plugin
export default {"wrapper":"_bad5550d"};